import React, { useState } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { Briefcase, Search, Save, FilePlus2, Tag } from 'lucide-react';
import { Input } from '../components/Input';
import { Textarea } from '../components/Textarea';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
import { Label } from '../components/Label';
import { Checkbox } from '../components/Checkbox';
import { toast } from 'sonner';
const results = [{
  id: 1,
  src: '@budis_pengamat • X',
  time: '15:42 WIB',
  text: 'Saya kira pemerintah perlu evaluasi mekanisme penyaluran bansos, terlalu banyak laporan distribusi tidak merata...',
  sent: 'NEG'
}, {
  id: 2,
  src: '@warga_demak • TikTok',
  time: '15:38 WIB',
  text: 'Bantuan untuk korban banjir Demak datang cepat, harapan kami terus berkelanjutan...',
  sent: 'POS'
}, {
  id: 3,
  src: '@infodaerah_up • IG',
  time: '15:31 WIB',
  text: 'INFO PENTING: bansos pangan dikabarkan dihentikan? Cek kebenaran ke sumber resmi.',
  sent: 'NEU'
}, {
  id: 4,
  src: '@kritik_pedas99 • X',
  time: '15:22 WIB',
  text: 'Pajak hiburan 75% benar-benar membunuh industri di Bali, banyak teman saya kena PHK...',
  sent: 'NEG'
}, {
  id: 5,
  src: '@sukmaa.n • TikTok',
  time: '15:15 WIB',
  text: 'MBG di sekolah anak saya bagus banget, terima kasih pak Presiden 🙏',
  sent: 'POS'
}, {
  id: 6,
  src: '@tanisejahtera_id • X',
  time: '15:09 WIB',
  text: 'Pupuk subsidi mulai sulit di gudang kami, mohon Kementan koordinasi dengan distributor...',
  sent: 'NEU'
}];
export function Workbench() {
  const [query, setQuery] = useState('bansos pangan');
  const [notes, setNotes] = useState('Catatan analis:\n- Hoaks distribusi tidak merata terdeteksi di WhatsApp Channels\n- Narasi terkoordinasi #BansosTidakAdil oleh 1.247 akun\n- Rekomendasi: Kemensos rilis data resmi 8 jam');
  const [isSaving, setIsSaving] = useState(false);
  const filteredResults = results.filter(r => r.text.toLowerCase().includes(query.toLowerCase()) || r.src.toLowerCase().includes(query.toLowerCase()));
  const handleSave = () => {
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      toast.success('Catatan investigasi berhasil disimpan');
    }, 800);
  };
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-3787">
      <PageHeader group="Workspace" title="Analyst Workbench" description="Ruang kerja analis: pencarian lintas-sumber, koleksi bukti, dan catatan investigasi." icon={Briefcase} data-id="element-3788" />

      <div className="grid grid-cols-12 gap-4 flex-1 min-h-[700px] lg:h-[700px]" data-id="element-3789">
        {/* Left: Data Sources */}
        <Card className="col-span-12 lg:col-span-3 bg-card border-border/50 overflow-y-auto" data-id="element-3790">
          <div className="p-3 border-b border-border/50 sticky top-0 bg-card/95 backdrop-blur z-10" data-id="element-3791">
            <h3 className="font-mono text-xs uppercase tracking-wider text-muted-foreground" data-id="element-3792">
              Filter Pencarian
            </h3>

            <div data-id="element-3793">
              <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3794">
                Query
              </Label>
              <div className="relative mt-1.5" data-id="element-3795">
                <Search className="absolute left-2 top-1/2 -translate-y-1/2 size-3.5 text-muted-foreground" data-id="element-3796" />
                <Input value={query} onChange={e => setQuery(e.target.value)} className="pl-7 bg-muted/30 border-border/50" data-id="element-3797" />
              </div>
            </div>

            <div data-id="element-3798">
              <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3799">
                Platform
              </Label>
              <div className="mt-1.5 space-y-1.5" data-id="element-3800">
                {['X', 'TikTok', 'Facebook', 'Instagram', 'YouTube'].map(p => <label key={p} className="flex items-center gap-2 text-xs" data-id="element-3801">
                      <Checkbox defaultChecked={['X', 'TikTok'].includes(p)} data-id="element-3802" />{' '}
                      {p}
                    </label>)}
              </div>
            </div>

            <div data-id="element-3803">
              <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3804">
                Sentimen
              </Label>
              <div className="mt-1.5 space-y-1.5" data-id="element-3805">
                {['Positif', 'Netral', 'Negatif'].map(s => <label key={s} className="flex items-center gap-2 text-xs" data-id="element-3806">
                    <Checkbox defaultChecked data-id="element-3807" /> {s}
                  </label>)}
              </div>
            </div>

            <div data-id="element-3808">
              <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3809">
                Wilayah
              </Label>
              <div className="mt-1.5 space-y-1.5" data-id="element-3810">
                {['Nasional', 'Jawa', 'Sumatera', 'Kalimantan', 'Sulawesi', 'Papua'].map(s => <label key={s} className="flex items-center gap-2 text-xs" data-id="element-3811">
                    <Checkbox defaultChecked={s === 'Nasional'} data-id="element-3812" /> {s}
                  </label>)}
              </div>
            </div>

            <Button size="sm" className="w-full" onClick={() => toast.success('Pencarian dijalankan')} data-id="element-3813">
              Cari (Ctrl+Enter)
            </Button>
          </div>
        </Card>

        {/* Middle: Results */}
        <Card className="col-span-12 lg:col-span-5 bg-card border-border/50 flex flex-col" data-id="element-3814">
          <div className="p-3 border-b border-border/50 flex items-center justify-between bg-muted/10" data-id="element-3815">
            <h3 className="font-mono text-xs uppercase tracking-wider text-muted-foreground" data-id="element-3816">
              Hasil Pencarian
            </h3>
            <Badge variant="outline" className="font-mono text-[9px]" data-id="element-3817">
              {filteredResults.length} Ditemukan
            </Badge>
          </div>
          <div className="flex-1 overflow-y-auto p-3 space-y-3" data-id="element-3818">
            {filteredResults.length > 0 ? filteredResults.map(r => <div key={r.id} className="p-3 rounded-lg border border-border/50 bg-muted/10 hover:bg-muted/20 transition cursor-pointer" data-id="element-3819">
                  <div className="flex items-center justify-between mb-1" data-id="element-3820">
                    <span className="font-mono text-[10px] text-muted-foreground" data-id="element-3821">
                      {r.src} • {r.time}
                    </span>
                    <span className={`font-mono text-[9px] ${r.sent === 'POS' ? 'text-emerald-500' : r.sent === 'NEG' ? 'text-red-500' : 'text-muted-foreground'}`} data-id="element-3822">
                      {r.sent}
                    </span>
                  </div>
                  <p className="text-xs leading-relaxed" data-id="element-3823">{r.text}</p>
                  <div className="flex gap-2 mt-2 opacity-0 group-hover:opacity-100 transition" data-id="element-3824">
                    <Button size="xs" variant="ghost" className="h-5 px-2 text-[9px]" onClick={() => toast.success('Ditambahkan ke evidence')} data-id="element-3825">
                      <FilePlus2 className="size-3 mr-1" data-id="element-3826" />
                      Bukti
                    </Button>
                    <Button size="xs" variant="ghost" className="h-5 px-2 text-[9px]" onClick={() => toast.success('Tag ditambahkan')} data-id="element-3827">
                      <Tag className="size-3 mr-1" data-id="element-3828" />
                      Tag
                    </Button>
                  </div>
                </div>) : <div className="h-full flex flex-col items-center justify-center text-muted-foreground opacity-50" data-id="element-3829">
                <Search className="size-10 mb-2" data-id="element-3830" />
                <p className="text-sm" data-id="element-3831">Tidak ada hasil ditemukan</p>
              </div>}
          </div>
        </Card>

        {/* Right: Notes */}
        <Card className="col-span-12 lg:col-span-4 bg-card border-border/50 flex flex-col" data-id="element-3832">
          <div className="p-3 border-b border-border/50 bg-card/95 backdrop-blur z-10" data-id="element-3833">
            <div className="flex items-center justify-between mb-3" data-id="element-3834">
              <h3 className="font-mono text-xs uppercase tracking-wider text-muted-foreground" data-id="element-3835">
                Catatan & Bukti
              </h3>
              <Button size="xs" variant="default" onClick={() => toast.success('Catatan disimpan')} data-id="element-3836">
                <Save className="size-3 mr-1" data-id="element-3837" />
                Simpan
              </Button>
            </div>
            <Textarea value={notes} onChange={e => setNotes(e.target.value)} className="bg-muted/20 border-border/50 text-xs font-mono flex-1 min-h-[400px] resize-none" data-id="element-3838" />
            <div className="mt-3 pt-3 border-t border-border/50" data-id="element-3839">
              <p className="font-mono text-[10px] text-muted-foreground mb-2" data-id="element-3840">
                BUKTI TER-PIN (3)
              </p>
              <div className="space-y-1.5" data-id="element-3841">
                {results.slice(0, 3).map(r => <div key={r.id} className="p-2 rounded bg-muted/20 border border-border/50 text-[10px]" data-id="element-3842">
                    <p className="font-mono text-muted-foreground" data-id="element-3843">{r.src}</p>
                    <p className="truncate" data-id="element-3844">{r.text}</p>
                  </div>)}
              </div>
            </div>
          </div>
          <div className="p-3 border-t border-border/50 bg-muted/10 flex justify-end gap-2" data-id="element-3845">
            <Button variant="outline" size="sm" data-id="element-3846">
              <FilePlus2 className="size-3.5 mr-1.5" data-id="element-3847" /> Lampirkan Bukti
            </Button>
            <Button size="sm" onClick={handleSave} disabled={isSaving} data-id="element-3848">
              <Save className="size-3.5 mr-1.5" data-id="element-3849" />{' '}
              {isSaving ? 'Menyimpan...' : 'Simpan Catatan'}
            </Button>
          </div>
        </Card>
      </div>
    </div>;
}